// src/components/home/HomeHero.tsx
import React from 'react';

const steps = [
  {
    title: 'Read the issue',
    description: 'Browse current political stories from multiple sources.',
  },
  {
    title: 'Take a position',
    description: 'Support or oppose the issue, or vote to help shape what rises.',
  },
  {
    title: 'Contribute or share',
    description:
      'Connect with aligned organizations, contribute through their pages, or share the campaign.',
  },
];

const HomeHero: React.FC = () => {
  return (
    <section className="mb-5 rounded-2xl border border-gray-200 bg-white shadow-sm overflow-hidden">
      <div className="grid grid-cols-1 gap-5 p-5 md:p-7 lg:grid-cols-[1.15fr_0.85fr]">
        <div className="flex flex-col justify-center">
          <p className="mb-3 text-sm font-semibold uppercase tracking-wide text-ballotr-blue">
            Political news, turned into action
          </p>

          <h1 className="text-3xl font-bold tracking-tight leading-tight text-textPrimary md:text-5xl">
            Read the issue.
            <br />
            Take a side.
            <br />
            Drive action.
          </h1>

          <p className="mt-4 max-w-2xl text-base text-textSecondary md:text-lg">
            Ballotr helps you move from political news to action: read the issue,
            support or oppose it, and connect with organizations tied to the outcome.
          </p>

          <div className="mt-6 flex flex-col gap-3 sm:flex-row">
            <a
              href="#campaign-feed"
              className="inline-flex items-center justify-center rounded-md bg-ballotr-blue px-5 py-3 text-sm font-semibold text-white transition hover:bg-ballotr-blue-light"
            >
              Take a side
            </a>
          </div>
        </div>

        <div className="rounded-xl border border-blue-100 bg-blue-50/70 p-5 md:p-6">
          <h2 className="mb-5 text-xl font-bold text-ballotr-blue">
           How Ballotr works
          </h2>

          <div>
            {steps.map((step, index) => (
              <div key={step.title} className="flex gap-4">
                <div className="flex flex-col items-center">
                  <div className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-blue-100 text-sm font-bold text-ballotr-blue">
                    {index + 1}
                  </div>

                  {index < steps.length - 1 && (
                    <div className="my-2 h-8 border-l-2 border-dotted border-blue-300" />
                  )}
                </div>

                <div className={index < steps.length - 1 ? 'pb-3' : ''}>
                  <p className="font-semibold text-textPrimary">{step.title}</p>
                  <p className="mt-1 text-sm text-textSecondary">
                    {step.description}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default HomeHero;